import { render, staticRenderFns } from "./udatalists.vue?vue&type=template&id=05291c67&"
import script from "./udatalists.vue?vue&type=script&lang=js&"
export * from "./udatalists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports